import type { Permission, PersonnelTmdPermission } from "src/api/Tmd.dtos";
import { PermissionScopeMode, type ILayoutItemContext } from "src/contexts/layouts/LayoutContext";

import hasPermission from "./hasPermission";
import hasPermissionAtAnyScope from "./hasPermissionAtAnyScope";

/**
 * Requires every requested permission using either contextual or any-scope matching.
 *
 * Postconditions: Missing or empty requirements pass, even without grants. Nonempty requirements
 * fail without grants. Contextual mode uses trial/institution IDs and is the default.
 */
const hasEveryPermission = (
    personnelTmdPermissions?: PersonnelTmdPermission[],
    permissions?: Permission[],
    context?: ILayoutItemContext,
    permissionScopeMode = PermissionScopeMode.Contextual
) => {
    if (!permissions || permissions.length === 0) {
        return true;
    }

    if (!personnelTmdPermissions || personnelTmdPermissions.length === 0) {
        return false;
    }

    return permissions.every(permission =>
        permissionScopeMode === PermissionScopeMode.Any
            ? hasPermissionAtAnyScope(personnelTmdPermissions, permission)
            : hasPermission(
                  personnelTmdPermissions,
                  permission,
                  context?.trialId,
                  context?.institutionId
              )
    );
};

export default hasEveryPermission;
